import { Box, Button, HStack, Tag, Text, VStack } from "@chakra-ui/react";
import ConsultantImage from "@components/ConsultantImage";
import CheckCircleIcon from "@components/icons/CheckCircleIcon";
import EmptyWhiteCircle from "@components/icons/EmptyWhiteCircle";

interface ConsultantProfileItemProps {
	image?: string;
	name?: string;
	id: string;
	description?: string;
	isSelected?: boolean;
	previouslyHired?: boolean;
	onSelect: (id: string) => void;
	onShowProfile: (id: string) => void;
}

const ConsultantProfileItem = ({
	image,
	name,
	description,
	id,
	isSelected = false,
	previouslyHired = false,
	onSelect,
	onShowProfile,
}: ConsultantProfileItemProps) => {
	return (
		<Box borderBottom={"1px solid #E3E3E3"}>
			<HStack p={4} justify={"space-between"}>
				<HStack>
					<ConsultantImage url={image} name={name} size="65px" placeholderFontSize="md" />

					<VStack mx={3} align={"start"}>
						<HStack justifyContent={"flex-start"}>
							<Text fontWeight={600} fontSize={"16px"} my={0}>
								{name}
							</Text>
							{previouslyHired && (
								<Tag bg={"#4BB769"} color={"#FFFFFF"}>
									Tidigare anlitad
								</Tag>
							)}
						</HStack>
						{description && (
							<Text fontSize={"14px"} fontWeight={400} color={"#999999"} my={0} noOfLines={2}>
								{description}
							</Text>
						)}
						<Button color="#219CD0" variant="link" onClick={() => onShowProfile(id)}>
							Visa profil
						</Button>
					</VStack>
				</HStack>
				<span style={{ cursor: "pointer" }} onClick={() => onSelect(id)}>
					{isSelected ? <CheckCircleIcon /> : <EmptyWhiteCircle />}
				</span>
			</HStack>
		</Box>
	);
};

export default ConsultantProfileItem;
